import { Box, Container, Heading, Link, SimpleGrid, Text } from '@chakra-ui/react'
import certificates from '../constants/certificates'
import { CalendarIcon, ExternalLinkIcon } from '@chakra-ui/icons'
import { AnimatePresence, motion, useInView } from 'framer-motion'
import { useRef } from 'react'

const Certificates = () => {
  const ref = useRef()
  const isInView = useInView(ref, { once: true })

  // console.log('isInView', isInView);

  return (
    <Box
      id="certificates"
      py={{
        base: 14,
        md: 20
      }}
      bgColor={'gray.200'}>
      <Container maxW={'container.xl'}>
        <AnimatePresence>
          <Box ref={ref} as={motion.div}>
            <Box
              display={'flex'}
              flexDirection={'column'}
              gap={2}
              mb={{
                base: 6,
                md: 12
              }}>
              <Heading
                textAlign={{
                  md: 'center'
                }}
                fontSize={{
                  base: '1.25rem',
                  md: '2rem'
                }}>
                Certificates
              </Heading>
              <Text
                textAlign={{
                  md: 'center'
                }}
                fontSize={{
                  base: '1rem',
                  md: '1rem'
                }}>
                These certificates reflect my commitment to ongoing learning and professional growth in the tech industry.
              </Text>
            </Box>

            {isInView && (
              <Box>
                <SimpleGrid
                  columns={{
                    base: 2,
                    md: 3,
                    lg: 4
                  }}
                  gap={{
                    base: 2.5
                  }}>
                  {certificates.map((certificate, i) => {
                    return <CertificateBox certificate={certificate} key={i} index={i} />
                  })}
                </SimpleGrid>
              </Box>
            )}
          </Box>
        </AnimatePresence>
      </Container>
    </Box>
  )
}

const CertificateBox = ({ certificate, index }) => {
  return (
    <AnimatePresence>
      <Box
        as={motion.div}
        initial={{
          opacity: 0,
          y: 50
        }}
        animate={{
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.75,
            delay: index * 0.15
            // ease: [0.6, 0.05, 0.2, 0.9],
          }
        }}
        height={'100%'}>
        <Link
          isExternal
          _hover={{
            textDecoration: 'none'
          }}
          href={certificate.url}>
          <Box
            px={{
              base: 3,
              md: 4
            }}
            _hover={{
              boxShadow: 'lg'
            }}
            py={{
              base: 3
            }}
            rounded={'lg'}
            height={'100%'}
            bgColor={'white'}>
            <Text
              fontSize={{
                base: '1rem',
                md: '1rem'
              }}
              fontWeight={700}>
              {certificate.name} <ExternalLinkIcon mt={-1} color={'green.600'} />
            </Text>
            <Text
              color={'green.600'}
              fontWeight={500}
              fontSize={{
                base: '.9rem',
                md: '.9rem'
              }}>
              {certificate.issuing_organization}
            </Text>
            <Text
              mt={1.5}
              color={'gray.600'}
              fontSize={{
                base: '.9rem',
                md: '.9rem'
              }}>
              <CalendarIcon fontSize={'.7rem'} mt={-0.5} /> Issued {certificate.issue_date}
            </Text>
          </Box>
        </Link>
      </Box>
    </AnimatePresence>
  )
}

export default Certificates
